export default "__VITE_ASSET__WgbBXjmt__"